import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

export const rbacGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {
  const auth = inject(AuthService);
  const router = inject(Router);

  if (!auth.isLoggedIn()) {
    return router.parseUrl('/guest/login');
  }

  const requiredRoles = (route.data?.['roles'] as string[]) || [];
  if (auth.hasRole(requiredRoles)) {
    return true;
  }

  return router.parseUrl('/access-denied');
};
